export default function SiteFooter() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const quickLinks = [
    { label: 'Home', id: 'hero' },
    { label: 'About', id: 'about' },
    { label: 'AI Voice Agent', id: 'ai-voice' },
    { label: 'Experience', id: 'experience' },
    { label: 'Services', id: 'services' },
    { label: 'Portfolio', id: 'portfolio' },
    { label: 'Contact', id: 'contact' },
  ];

  const connectLinks = [
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/peter-michael-gits/', icon: 'ri-linkedin-fill', hoverColor: 'hover:text-teal-400' },
    { label: 'Jessica Admin', href: 'https://jessica.petergits.com', icon: 'ri-robot-line', hoverColor: 'hover:text-teal-400' },
    { label: 'Betty', href: 'https://betty.readdy.co', icon: 'ri-shopping-basket-line', hoverColor: 'hover:text-amber-400' },
    { label: 'Stephanie', href: 'https://stephanie.readdy.co', icon: 'ri-restaurant-line', hoverColor: 'hover:text-rose-400' },
    { label: 'VoiceCal Demo', href: 'https://minasdesignsai.org', icon: 'ri-mic-line', hoverColor: 'hover:text-teal-400' },
  ];

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/b0d28b98390413eddff47342c2e73859/20aa6e2d8ba050ef68f0ff711571da9e.png"
                alt="GITS Logo"
                className="h-12 w-auto object-contain"
              />
              <div>
                <div className="font-bold text-white text-sm leading-tight">GITS - Global Innovation</div>
                <div className="font-bold text-white text-sm leading-tight">Technology Solutions</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm mb-6">
              Helping businesses harness the power of &apos;Conversational AI&apos; to drive growth, efficiency, and competitive advantage.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.linkedin.com/in/peter-michael-gits/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-teal-500 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="mailto:pgits@minasdesignsai.org"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-teal-500 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a
                href="tel:+17433005858"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-teal-500 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-phone-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="text-gray-400 hover:text-teal-400 text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">Connect</h4>
            <ul className="space-y-3">
              {connectLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center gap-2 text-gray-400 ${link.hoverColor} text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap`}
                  >
                    <i className={`${link.icon} text-base`}></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-3">Contact</h4>
              <div className="space-y-2 text-sm text-gray-400">
                <div>support@gits.agency</div>
                <div>+1 (743) 300-5858</div>
                <div>509 Vermeer Court<br />Mount Holly, NC 28120</div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} GITS - Global Innovation Technology Solutions. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-gray-500">
            <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">Privacy Policy</a>
            <span className="text-gray-700">|</span>
            <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
